/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicQrCodeScan.internal

import features.publicQrCodeScan.models.PublicQrCodeScanResponseModel
import features.publicQrCodeScan.models.ScanPublicQrCodeRequest
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.publicQrCodeScan.internal.ScanningPublicQrCodeUseCase.Params

internal class ScanningPublicQrCodeUseCase : AsyncUseCase<PublicQrCodeScanResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val scanPublicQrCodeRequest: ScanPublicQrCodeRequest
    )

    private val scanningPublicQrCodeService: ScanningPublicQrCodeService = ScanningPublicQrCodeServiceImpl()

    override suspend fun run(params: Params): Result<PublicQrCodeScanResponseModel> {
        return scanningPublicQrCodeService.scanPublicQrCode(
            overrideHeaders = params.overrideHeaders,
            scanPublicQrCodeRequest = params.scanPublicQrCodeRequest
        )
    }
}
